import { ClaimType } from '@constants';
import { PageTitle, BottomButtons } from '@components';
import RadioGroup from './radio-group';
import classes from './index.module.css';
import { useChoose } from './hooks';

const TITLE_TEXT = {
  [ClaimType.Theft]: 'Tell us which package is stolen',
  [ClaimType.Delay]: 'Tell us which package is delayed',
  [ClaimType.Damage]: 'Tell us which package suffered damage',
  [ClaimType.Loss]: 'Tell us which package is lost',
};
export default function PackageChoose() {
  const {
    type,
    isBtnDisable,
    onClickContinue,
    onClickBack,
  } = useChoose();
  return (
    <div className={classes.content}>
      <PageTitle title={TITLE_TEXT[type]} />
      <RadioGroup />
      <BottomButtons
        isContinueDisabled={isBtnDisable}
        onClickContinue={onClickContinue}
        onClickBack={onClickBack}
      // isContinueLoading={isLoading}
      />
    </div>

  );
}
